import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarPortal } from '@plone/volto/components';

import View from './View';
import Data from './Data';

/**
 * Editor do bloco "Imprensa".
 *
 * O índice do contato aberto vive aqui, uma vez só — duplicá-lo dentro da View
 * é o bug que `homeBannerPortal` carrega. `-1` mantém o `ObjectListWidget`
 * controlado com todos os itens fechados.
 */
const Edit = (props) => {
  const { block, data, onSelectBlock, selected } = props;
  const [activeItem, setActiveItem] = React.useState(-1);

  const handleEditItem = React.useCallback(
    (index: number) => {
      // Sem selecionar o bloco o `SidebarPortal` nem chega a montar.
      onSelectBlock?.(block);
      setActiveItem(index);
      // Depois do próximo paint, com o acordeão já expandido: a lista tem
      // dezenas de itens e o aberto costuma cair fora da área visível.
      window.requestAnimationFrame(() => {
        document
          .getElementById('blockform-fieldset-contatos')
          ?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
    },
    [block, onSelectBlock],
  );

  return (
    <>
      <View {...props} data={data} isEditMode onEditItem={handleEditItem} />

      <SidebarPortal selected={selected}>
        <Data
          {...props}
          activeObject={activeItem}
          setActiveObject={setActiveItem}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(Edit);
